import api, { ApiResponse } from './api';

import { CurrentFlag } from 'entities/CurrentFlag';

interface GetCurrentFlagListResponse {
  success: boolean;
  data: CurrentFlag[];
}

export const getCurrentFlagListService =
  (): ApiResponse<GetCurrentFlagListResponse> =>
    api({
      method: 'GET',
      url: 'current-flags',
      useToken: true,
    });
